import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Creators as CartCreators } from '../../reducers/cart';
import { Types, Creators as CheckoutCreators } from '../../reducers/checkout';
import { Creators as FreightCreators } from '../../reducers/freights';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* checkoutAddressRequest({ address, noCalcFreight }) {
  try {
    const { cart, customer, delivery, app } = yield select(getState);
    const token = yield select(getToken);

    const { sellers } = cart;

    const cartId = cart.id || customer.cartId || getCartId();
    const siteId = app.getIn(['config', 'siteId']);

    for (const seller of sellers) {
      const sellerId = seller.getIn(['seller', 'id']);

      if (!delivery.getIn(['selectedDelivery', sellerId, 'isStore']) && !noCalcFreight) {
        yield call(checkoutAPI.setAddressToDelivery, cartId, address.id, token, siteId, sellerId);
        yield put(FreightCreators.selectFreight({ [sellerId]: null }));
      }
    }

    yield put(CartCreators.cartRequest());
    yield put(CheckoutCreators.checkoutRequest());

    yield put(CheckoutCreators.checkoutAddressSuccess());
  } catch (error) {
    yield put(CheckoutCreators.checkoutAddressFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CHECKOUT_ADDRESS_REQUEST, checkoutAddressRequest);
}
